exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".information-header[data-v-cfd0f720]{font-size:18px;line-height:32px;color:#fff;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;min-height:40px}@media only screen and (min-width: 1025px){.information-header[data-v-cfd0f720]{padding:6px 85px}}@media only screen and (min-width: 768px) and (max-width: 1024px){.information-header[data-v-cfd0f720]{padding:6px 20px}}@media only screen and (max-width: 767px){.information-header[data-v-cfd0f720]{font-size:14px;line-height:18px;padding:10px 20px;padding-right:52px}}\n", ""]);

// exports
